import { Factory, HttpFilter, NameValue, SettingsService } from '@infodata-group/inf-commons';
import dayjs from 'dayjs';
import { AoPath } from '../../model/path/ao-path';

export class AoPathFactory implements Factory<AoPath> {
  protected _date: Date;
  protected _id: string;
  protected _settingsService: SettingsService;

  constructor(id: string, date: Date, settingsService: SettingsService) {
    this._id = id;
    this._date = date;
    this._settingsService = settingsService;
  }

  public getHttpFilters(): HttpFilter {
    return new HttpFilter([new NameValue('date', dayjs(this._date).format('DD/MM/YYYY'))]);
  }

  build(o: any): AoPath {
    return undefined;
  }

  getApi(): string {
    return '';
  }
}
